import { Box, BoxProps, rem } from '@mantine/core'

import { useExpertStore } from 'state/expert'

import { _CardPost } from './_cardPost'

export const _RelatedPostCards = ({ ...rest }: BoxProps) => {
  const { relatedCardPosts, relatedCardPostComments } = useExpertStore(
    (state) => ({
      relatedCardPosts: state.relatedCardPosts,
      relatedCardPostComments: state.relatedCardPostComments,
    }),
  )
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        gap: rem(24),
        [theme.fn.smallerThan('md')]: { flexDirection: 'column', gap: rem(16) },
      })}
      {...rest}
    >
      {relatedCardPosts?.map((i) => (
        <_CardPost
          key={String(i.id)}
          post={i}
          sx={(theme) => ({
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'stretch',
            width: '100%',
            gap: rem(12),
            [theme.fn.largerThan('md')]: {
              width: `calc(50% - ${rem(24)})`,
              gap: rem(24),
            },
          })}
        />
      ))}
      {relatedCardPostComments?.map((i) => (
        <_CardPost
          key={String(i.id)}
          post={i}
          hasExpertComment
          sx={(theme) => ({
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'stretch',
            width: '100%',
            gap: rem(12),
            [theme.fn.largerThan('md')]: {
              width: `calc(50% - ${rem(24)})`,
              gap: rem(24),
            },
          })}
        />
      ))}
    </Box>
  )
}
